module.exports = __webpack_public_path__ + "media/landing_page/thumbnail-b358bde6e459b420c0a3f52243762cb3-5472d54c.png";